/**
 * React entry point — included from `src/index.html`.
 */

import { bootBusinessEngineFrontend } from "./frontend-boot";

bootBusinessEngineFrontend(import.meta.hot?.data ?? {});
